import { useLayoutEffect, useEffect, useState, useRef } from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress'
import { SxProps } from '@mui/system/styleFunctionSx/styleFunctionSx';

const DataLoading = () => {
  let topContaner = useRef();
  let userMessge: any = useRef();
  let progressIndicator = useRef();

  let topContainerProps: SxProps = { width: 1, backgroundColor: "#F4D03F", textAlign: "center", p: 3 };

  let userMessgeProps: SxProps = { m: 2, color: "Black", fontSize: "24px" };

  let progressIndicatorProps: SxProps = { mt: "18px", color: "Black" };

  useLayoutEffect(() => {
    if (topContaner.current) {
      const container = topContaner.current as HTMLElement;
      container.style.height = `${window.innerHeight - 50}px`;
    }
    // var indicator: HTMLElement = progressIndicator.current as HTMLElement;
  });

	const [loadingMessage, setLoadingMessage] = useState(
		<span>
			Loading your reports
			<img
				src="/assets/placeholders/ellipsis.svg"
				style={{ display: 'inline-block', margin: '8px 0px 0 -2px' }}
			/>
		</span>
	);
	useEffect(() => {
		const timer1 = setTimeout(() => {
			setLoadingMessage(
				<span>
					Your reports are on the way!
					<br />
					Just another moment
					<img
						src="/assets/placeholders/ellipsis.svg"
						style={{
							display: 'inline-block',
							margin: '8px 0px 0 -2px',
						}}
					/>
				</span>
			);
		}, 6000);
		const timer2 = setTimeout(() => {
			setLoadingMessage(
				<span>
					<strong>Still loading. Thanks for your patience.</strong>{' '}
					<br />
					
					<span
						style={{
							fontSize: '13px',
							display: 'inline-block',
							marginTop: '15px',
							maxWidth: '400px',
							fontStyle: 'italic',
							borderTop: '1px solid white',
							paddingTop: '15px',
						}}
					>
						<strong>Tip:</strong> If your load time is consistently this slow, <br></br>contact our support team for assistance.
					</span>
				</span>
			);
		}, 15000);
		return () => {
			clearTimeout(timer1);
			clearTimeout(timer2);
		};
	}, []);

  return (
<div
						style={{
							position: 'fixed',
							height: '100vh',
							width: '100vw',
							background: 'rgba(255,255,255,.0)',
							top: '0px',
							zIndex: '1000000',
							overflow: 'hidden',
							backdropFilter: 'blur(1.4px)',
						}}
					>
						<div
							className="wave-container"
							style={{
								margin: '60px auto 0',
								position: 'fixed',
								height: '100vh',
								background: '#0092c8',
								top: '0px',
								zIndex: '1000001',
							}}
						>
							<img
								src="/assets/placeholders/Wave@1x-10.0s-1920px-720px.svg"
								alt="Loading..."
								style={{ marginTop: '0px' }}
							/>
						</div>
						<div
							id="loading"
							className="flex justify-center"
							style={{ position: 'relative', zIndex: '1000002' }}
						>
							<div
								style={{
									margin: '33vh auto 0',
									maxWidth: '100%',
									color: 'white',
									fontFamily: 'jost',
									fontSize: '18px',
									textAlign: 'center',
								}}
							>
								<img
									src="/assets/logos/LuminUltra_Main_Logo_White_With_Tag2.svg"
									alt="LuminUltra logo"
									style={{
										margin: '0 0 30px 0',
										width: '440px',
									}}
								/>
								{loadingMessage}
							</div>
						</div>
					</div>
  );

}

export default DataLoading;